document.addEventListener('DOMContentLoaded', () => {
    const scrollDownTriggers = document.querySelectorAll('.js-scrollDown');
    scrollDownTriggers.forEach((elem) => {
        elem.addEventListener('click', () => {
            const intro = elem.parentElement.parentElement.parentElement;
            const height = intro.scrollHeight + 105;
            window.scrollTo({ top: height })
        })
    })

})